import {Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges} from '@angular/core';
import MetisMenu from 'metismenujs/dist/metismenujs';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../core/services/auth.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {

    @Input() isCondensed = false;
    menu: any;
    menuList;
    translation;

    @ViewChild('sideMenu', {static: false}) sideMenu: ElementRef;

    constructor(public translate: TranslateService, private authenticationService: AuthenticationService) {
        this.translate.addLangs(['en', 'de']);
        if (localStorage.getItem('locale')) {
            const browserLang = localStorage.getItem('locale');
            translate.use(browserLang.match(/en|de/) ? browserLang : 'en');
        } else {
            localStorage.setItem('locale', 'en');
            translate.setDefaultLang('en');
        }
    }

    ngOnInit() {
        this.translate.get([
            'menu.navigation',
            'menu.dashboard',
            'menu.quote_request',
            'menu.job_orders',
            'menu.calendar',
            'menu.clients',
            'menu.workshop',
            'menu.invoices',
            'menu.settings',
            'menu.configurations',
            'menu.service',
            'menu.car_brands',
            'menu.status',
            'menu.car_models',
            'menu.user_type',
            'menu.service_category',
            'menu.body_type',
            'menu.vendor',
            'menu.user',
            'menu.workshop',
        ]).subscribe((res: string) => {
            this.translation = res;
            const currentUser = this.authenticationService.currentUser();
            let isAdmin = false;
            let allowedRoutes = [];
            switch (currentUser.type) {
                case 1:
                    isAdmin = true;
                    break;
                case 2:
                    allowedRoutes = [];
                    break;
                case 3:
                    allowedRoutes = [
                        'menu.dashboard',
                    ];
                    break;
            }
            this.menuList = [
                {
                    menuName: this.translation['menu.navigation'], parent: true, list: [
                        {
                            menuName: this.translation['menu.dashboard'],
                            route: '/dashboard/dashboard1',
                            icon: 'remixicon-pie-chart-2-line',
                            name: 'menu.dashboard'
                        },
                        {
                            menuName: this.translation['menu.quote_request'],
                            route: '/apps/tickets',
                            icon: 'remixicon-stack-fill',
                            name: 'menu.quote_request'
                        },
                        {
                            menuName: this.translation['menu.job_orders'],
                            route: '/auftrage/auftragsnummer',
                            icon: 'remixicon-award-fill',
                            name: 'menu.job_orders'
                        },
                        {
                            menuName: this.translation['menu.calendar'],
                            route: '/apps/calendar',
                            icon: 'remixicon-group-fill',
                            name: 'menu.calendar'
                        },
                        {
                            menuName: this.translation['menu.clients'],
                            route: '/kunde/kunden',
                            icon: 'remixicon-user-2-fill',
                            name: 'menu.clients'
                        },
                        {
                            menuName: this.translation['menu.workshop'],
                            route: '/werkstatt/allewerkstatt',
                            icon: 'remixicon-file-text-line',
                            name: 'menu.workshop'
                        },
                        {
                            menuName: this.translation['menu.invoices'],
                            route: '/extras/invoice',
                            icon: 'remixicon-bill-fill',
                            name: 'menu.invoices'
                        },
                        {
                            menuName: this.translation['menu.settings'],
                            route: '/settings/account',
                            icon: 'remixicon-settings-5-fill',
                            name: 'menu.settings'
                        },
                    ].filter(value => {
                        return allowedRoutes.includes(value.name) || isAdmin;
                    })
                },
                {
                    menuName: this.translation['menu.configurations'], parent: true, list: [
                        {
                            menuName: this.translation['menu.service_category'],
                            route: '/settings/service_category',
                            icon: 'remixicon-list-unordered',
                            name: 'menu.service_category'
                        },
                        {
                            menuName: this.translation['menu.service'],
                            route: '/settings/service',
                            icon: 'remixicon-list-unordered',
                            name: 'menu.service'
                        },
                        {
                            menuName: this.translation['menu.car_brands'],
                            route: '/settings/car-brands',
                            icon: 'remixicon-car-fill',
                            name: 'menu.car_brands'
                        },
                        {
                            menuName: this.translation['menu.car_models'],
                            route: '/settings/car-models',
                            icon: 'remixicon-car-line',
                            name: 'menu.car_models'
                        },
                        {
                            menuName: this.translation['menu.status'],
                            route: '/settings/status',
                            icon: 'remixicon-list-unordered',
                            name: 'menu.status'
                        },
                        {
                            menuName: this.translation['menu.user_type'],
                            route: '/settings/user-type',
                            icon: 'remixicon-list-unordered',
                            name: 'menu.user_type'
                        },
                        {
                            menuName: this.translation['menu.body_type'],
                            route: '/settings/car-body-type',
                            icon: 'remixicon-list-unordered',
                            name: 'menu.body_type'
                        },
                        {
                            menuName: this.translation['menu.vendor'],
                            route: '/settings/vendor',
                            icon: 'remixicon-list-unordered',
                            name: 'menu.vendor'
                        },
                        {
                            menuName: this.translation['menu.workshop'],
                            route: '/settings/workshop',
                            icon: 'remixicon-list-unordered',
                            name: 'menu.workshop'
                        },
                        {
                            menuName: this.translation['menu.user'],
                            route: '/settings/user',
                            icon: 'remixicon-list-unordered',
                            name: 'menu.user'
                        },
                    ].filter(value => {
                        return allowedRoutes.includes(value.name) || isAdmin;
                    })
                },
            ].filter(value => {
                return value.list.length > 0;
            });
        });
    }

    ngAfterViewInit() {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);

        this._activateMenuDropdown();
    }

    ngOnChanges() {
        if (!this.isCondensed && this.sideMenu || this.isCondensed) {
            setTimeout(() => {
                this.menu = new MetisMenu(this.sideMenu.nativeElement);
            });
        } else if (this.menu) {
            this.menu.dispose();
        }
    }

    /**
     * small sidebar
     */
    smallSidebar() {
        document.body.classList.add('left-side-menu-sm');
        document.body.classList.remove('left-side-menu-dark');
        document.body.classList.remove('topbar-light');
    }

    /**
     * Dark sidebar
     */
    darkSidebar() {
        document.body.classList.remove('left-side-menu-sm');
        document.body.classList.toggle('left-side-menu-dark');
    }

    /**
     * Light Topbar
     */
    lightTopbar() {
        document.body.classList.add('left-side-menu-dark');
        document.body.classList.add('topbar-light');
        document.body.classList.remove('left-side-menu-sm');
        document.body.classList.remove('enlarged');

    }

    /**
     * Sidebar collapsed
     */
    sidebarCollapsed() {
        document.body.classList.add('enlarged');
        document.body.classList.remove('left-side-menu-dark');
        document.body.classList.remove('left-side-menu-sm');
        document.body.classList.remove('boxed-layout');

    }

    /**
     * Boxed Layout
     */
    boxedLayout() {
        document.body.classList.toggle('boxed-layout');
        document.body.classList.remove('left-side-menu-dark');
        document.body.classList.add('enlarged');
    }

    /**
     * Activates the menu dropdown
     */
    _activateMenuDropdown() {
        const links = document.getElementsByClassName('side-nav-link-ref');
        let menuItemEl = null;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < links.length; i++) {
            // tslint:disable-next-line: no-string-literal
            if (window.location.pathname === links[i]['pathname']) {
                menuItemEl = links[i];
                break;
            }
        }

        if (menuItemEl) {
            menuItemEl.classList.add('active');

            const parentEl = menuItemEl.parentElement;
            if (parentEl) {
                parentEl.classList.add('active');

                const parent2El = parentEl.parentElement;
                if (parent2El) {
                    parent2El.classList.add('in');
                }

                const parent3El = parent2El.parentElement;
                if (parent3El) {
                    parent3El.classList.add('active');
                    parent3El.firstChild.classList.add('active');
                }
            }
        }
    }

}
